import { buildInvoiceDoctorInfo } from "../NewSales/utils/doctorFormUtils";

const toNum = (value) => {
	const num = Number(value);
	return Number.isFinite(num) ? num : 0;
};

/**
 * Map a saved sale record to POS InvoiceModal invoiceData shape.
 */
export const buildInvoiceFromSale = (sale, getCurrencySymbol) => {
	if (!sale) return null;

	const currency = sale.currencyType || "INR";
	const isIGST = Boolean(sale.isIGST);

	const items = (sale.items || []).map((item) => ({
		_id: item.itemId || item.stockId,
		brandName: item.brandName || item.medicineName,
		batchNumber: item.batchNumber,
		quantity: toNum(item.medicineQunatity) || 1,
		salePrice: toNum(item.unitPricePerMedicine) || toNum(item.MRP),
		tax: toNum(item.tax),
		taxPercentage: toNum(item.taxPercentage),
		CGST: toNum(item.CGST),
		SGST: toNum(item.SGST),
		IGST: toNum(item.IGST),
	}));

	const subtotal = items.reduce((sum, item) => {
		const lineTotal = item.salePrice * item.quantity;
		const rate = item.taxPercentage;
		if (rate <= 0) return sum + lineTotal;
		return sum + lineTotal / (1 + rate / 100);
	}, 0);

	const discount =
		String(sale.discountType || "").toLowerCase() === "percentage"
			? (subtotal * toNum(sale.discount)) / 100
			: toNum(sale.discount);

	const prescribedDoctor = sale.doctor
		? buildInvoiceDoctorInfo(sale.doctor)
		: null;

	return {
		date: sale.createdAt || new Date().toISOString(),
		invoiceNo: sale.salesNumber,
		customer: sale.patientName || "Walk-in Customer",
		...(prescribedDoctor ? { prescribedDoctor } : {}),
		items,
		subtotal,
		discount,
		tax: toNum(sale.tax),
		CGST: toNum(sale.CGST),
		SGST: toNum(sale.SGST),
		IGST: toNum(sale.IGST),
		VAT: 0,
		total: toNum(sale.netTotal),
		paid: toNum(sale.totalPaid),
		taxType: isIGST ? "GST" : "GST",
		taxPercentage: toNum(sale.taxPercentage),
		CGSTPercentage: toNum(sale.CGSTPercentage),
		SGSTPercentage: toNum(sale.SGSTPercentage),
		IGSTPercentage: toNum(sale.IGSTPercentage),
		isSameState: !isIGST,
		isIGST,
		currency,
		currencySymbol: getCurrencySymbol?.(currency) || currency,
		discountMeta: {
			type: String(sale.discountType || "").toLowerCase() === "percentage" ? "Percentage" : "Fixed",
			value: toNum(sale.discount),
		},
		paymentType: sale.paymentType || "cash",
		pharmacyStateCode: "",
		patientStateCode: "",
		receiptQrData: null,
	};
};

export const getDoctorContactDisplay = (doctor = {}) => {
	if (!doctor) return null;
	const info = buildInvoiceDoctorInfo(doctor);
	if (!info?.contact) return null;
	const labels = { phone: "Tel", email: "Email", clinic: "Clinic" };
	return {
		label: labels[info.contactLabel] || "Contact",
		value: info.contact,
	};
};
